import { useEffect, useState } from 'react'
import useAxios from '../../hooks/useAxios'
import { PaginationResponseInterface } from '../../types/pagination'
import SelectSearchMultiple, { IOptionSelect } from '../SelectSearchMultiple'
import SelectSearch from '.'
import { IDistributionChannel } from '../../types/distribution-channel'
import { ImageLinks, LogoTypeSocial } from '../../constants/image-link'
import { Autocomplete, TextField } from '@mui/material'

interface Props {
  handleFilterChange?: (filter: any) => void
  selected?: string[]
  onSelect: (e: any) => void
  resetAutoComplete?: string
  label?: string
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  helperText?: string | any
  error?: boolean | any
  name?: string
  multiple?: boolean
  defaultValue?: any
}

const ChannelSelectMultipleSearch = (props: Props) => {
  const {
    handleFilterChange,
    selected,
    onSelect,
    resetAutoComplete = '',
    label = 'เลือกช่องทางการขาย',
    multiple = true,
    ...rest
  } = props
  const [search, setSearch] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search)

  const { data, isLoading } = useAxios<
    PaginationResponseInterface<IDistributionChannel>
  >({
    method: 'GET',
    url: '/distribution-channels',
    params: {
      page: 1,
      perPage: 15,
      search: debouncedSearch,
      startDate: '',
      endDate: '',
      hideInActive: true,
    },
  })

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [search])

  const handleSearch = async (value: string) => {
    setSearch(value)
  }

  const currentLoadingState = loading || isLoading

  if (!data?.records) {
    return <></>
  }

  return (
    <>
      <Autocomplete
        multiple={true}
        value={data?.records
          .filter((option) => selected?.includes(option.objectId))
          .map((option) => ({
            label: option.name,
            value: option,
            image:
              ImageLinks[`LOGO_${option.type.toUpperCase()}` as LogoTypeSocial],
          }))}
        onChange={(event: any, data: any[]) => {
          onSelect(data.filter((option) => option !== undefined))
        }}
        options={
          data?.records
            // .filter(
            //   (distributionChannel: IDistributionChannel) =>
            //     !selected?.includes(distributionChannel.objectId),
            // )
            .map((distributionChannel: IDistributionChannel) => ({
              label: distributionChannel.name,
              value: distributionChannel,
              image:
                ImageLinks[
                  `LOGO_${distributionChannel.type.toUpperCase()}` as LogoTypeSocial
                ],
            })) || ([] as IOptionSelect<IDistributionChannel>[])
        }
        renderInput={(params) => (
          <TextField
            key={params.id}
            {...params}
            label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
            placeholder={`${label} ${
              currentLoadingState ? 'กำลังโหลด...' : ''
            }`}
          />
        )}
        onInputChange={(event: any, data: string) => {
          handleSearch(data)
        }}
      />
    </>
  )
}

export default ChannelSelectMultipleSearch
